/**
 * Sign-out flows that must leave the SPA and clear cookies/session reliably use `window.location.href`
 * (not React Router `navigate`), after `AccountApi.logoutUser()` completes.
 */
import { AccountApi } from "../services";
import { ApplicationRoutes } from "../../components/routes/config";

const basePath = process.env.REACT_APP_BASEPATH ?? "";

function signoutRedirectCustom(): void {
  const isDirectAccess = JSON.parse(
    sessionStorage.getItem("isDirectAccess") || "false"
  );
  AccountApi.logoutUser().then(() => {
    sessionStorage.removeItem("isDirectAccess");
    if (isDirectAccess) {
      window.location.href = basePath + ApplicationRoutes.ShowSessionTimeout;
    } else {
      sessionStorage.removeItem("token");
      const clientAppValue = JSON.parse(
        sessionStorage.getItem("ClientApp") as string
      );
      window.location.href = basePath + "/" + clientAppValue.AppName;
    }
  });
}
const signOutService = {
  signoutRedirectCustom,
};

export default signOutService;
